<template>
  <v-card class="create-announcement">
    <v-card-actions class="px-3 pt-3">
      <h5 class="title">
        Make new annoucement
      </h5>
      <v-spacer />
      <span class="caption grey--text text--lighten-1">
        Date:
        {{ new Date() | moment('Do MMM YYYY') }}
      </span>
    </v-card-actions>
    <v-card-text class="pt-0">
      <v-text-field
        :error-messages="errors.collect('title')"
        data-vv-name="title"
        data-vv-as="title"
        v-validate="'required|max:255'"
        label="Title"
        v-model="newTitle"
      />
      <v-textarea
        :error-messages="errors.collect('announcement')"
        data-vv-name="announcement"
        data-vv-as="announcement"
        v-validate="'required|max:10000'"
        label="Announcement"
        v-model="newAnnouncement"
      />
    </v-card-text>
    <v-card-actions class="px-3">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        text
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        send announcement to class
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import Class from '@/modules/class/models/Class'

export default {
  name: 'CreateAnnouncement',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    customClass: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newTitle: '',
      newAnnouncement: '',
      loading: false
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async save() {
      // validate form
      let result = await this.$validator.validateAll()
      if (!result) return // there are errors

      const payload = {
        title: this.newTitle,
        messages: this.newAnnouncement,
        custom_class_id: this.customClass.id,
        module: 'teacher'
      }
      this.loading = true
      try {
        await Class.dispatch('addMessage', {
          payload: payload
        })
        this.showSnackbar('Announcement sent to class')
      } catch (error) {
        this.loading = false
        this.showErrorSnackbar('There was a server error. Contact support')
      }
      this.newTitle = ''
      this.newAnnouncement = ''

      this.loading = false
      this.$emit('createdAnnouncement')
    }
  }
}
</script>

<style lang="scss" scoped>
.create-announcement {
  .date {
    color: var(--v-primary-base);
    font-size: 20px;
  }
}
</style>
